import * as styles from './styles.css';
import { Button } from '@mui/material';
import Edit from '@mui/icons-material/Edit';
import { atom } from 'jotai/vanilla';
import { useSetAtom } from 'jotai/react';
import atoms from '../../atoms';
import { ISection, IFrame } from '../../interfaces';

export interface ISectionHeaderProps {
  id: string;
  section_id: string;
  name: string;
}

const go_to_section = atom(null, (get, set, section_id: string) => {
  const sections = get(atoms.frame.sections) as ISection[];
  const section = sections.find((section) => section.id === section_id);
  if (section) {
    const frames = section.frames.map((frame) => {
      // Inform components they're in "review mode" in case that's important
      const components = frame.components.map((component) => ({
        ...component,
        in_review: true,
      }));
      return { ...frame, components };
    });
    set(atoms.application.is_in_review, true); // Sets the application to "review mode"
    set(atoms.frame.update, {
      active_section: {
        application_id: (get(atoms.frame.data) as IFrame).application_id,
        button: section.button,
        section: section.id,
        sections: sections,
        frames,
      },
    }); // Sets active component list to the components in this section
  }
});

const SectionHeader = ({ id, name, section_id }: ISectionHeaderProps) => {
  const onClick = useSetAtom(go_to_section);
  return (
    <div id={id} className={styles.section.container_header}>
      <div className={styles.section.container_title}>{name}</div>
      <Button
        className={styles.section.edit_button}
        variant="text"
        color="primary"
        size="small"
        onClick={() => onClick(section_id)}
      >
        <Edit />
        Edit
      </Button>
    </div>
  );
};

export default SectionHeader;
